import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import LanguageToggle from "@/components/site/LanguageToggle";
import logo from "@/assets/szn-trip.webp";

export default function LegalPage({ page }) {
  const { t } = useLang();
  const L = t.legalPage;
  const title = page === "privacy" ? L.privacyTitle : L.mentionsTitle;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F1E8]" data-testid={`legal-page-${page}`}>
      <div className="noise-overlay" />
      <header className="border-b-2 border-[#14283A]/10">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-4">
          <Link to="/" data-testid="legal-logo">
            <img src={logo} alt="SZN Trip" className="h-10 w-auto" />
          </Link>
          <LanguageToggle />
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16 sm:py-24">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-2 text-sm font-bold text-[#14283A] transition-colors hover:text-[#EA7A4F]"
          data-testid="legal-back"
        >
          <ArrowLeft className="h-4 w-4" /> {L.backHome}
        </Link>

        <div className="flex items-center gap-3">
          <h1 className="font-display text-4xl text-[#14283A] sm:text-5xl">{title}</h1>
        </div>
        <span className="mt-3 inline-block rounded-full grad-bar px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">
          {L.draft}
        </span>

        <div className="mt-8 space-y-5 rounded-2xl border-2 border-[#14283A] bg-white p-8 shadow-[6px_6px_0_0_#14283A]">
          <p className="text-lg leading-relaxed text-[#14283A]/80">{L.draftBody}</p>
          <div className="border-t-2 border-dashed border-[#14283A]/20 pt-5 text-sm text-[#14283A]/70">
            <p className="font-semibold text-[#14283A]">Nouvelles Destinations</p>
            <p>{t.footer.legal.atout} <span className="italic opacity-60">{t.footer.legal.toComplete}</span></p>
            <p className="mt-3">{L.contact}</p>
          </div>
        </div>
      </main>
    </div>
  );
}
